import React from "react";
import Seo from "../components/site/Seo";
import { PrimaryButton, ArrowLink, BrandMark } from "../components/site/Bits";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | LYKIT Entertainment Pvt. Ltd." description="The page you are looking for does not exist." />
      <section className="lk-section" style={{ paddingTop: "clamp(132px,14vh,178px)" }}>
        <div className="lk-container-wide">
          <div
            className="relative isolate overflow-hidden rounded-[26px] px-[clamp(28px,5vw,80px)] py-[clamp(38px,4vw,66px)]"
            style={{ background: "var(--lykit-near-black)", border: "1px solid rgba(216,183,122,0.35)" }}
            data-testid="not-found-panel"
          >
            <div className="grain absolute inset-0" aria-hidden="true" style={{ opacity: 0.6 }} />
            <div className="relative z-10 max-w-[46ch]">
              <BrandMark size={20} />
              <p
                className="mt-8 text-[11.5px] font-medium uppercase"
                style={{ letterSpacing: "0.22em", color: "rgba(216,183,122,0.9)" }}
              >
                404
              </p>
              <h1 className="display-xl mt-5" style={{ color: "#FBFAF7" }}>
                THIS SCENE DOESN'T EXIST.
              </h1>
              <p className="mt-7 text-[15px] leading-[1.7]" style={{ color: "rgba(247,246,242,0.74)" }}>
                The page you were looking for has moved or never made the final cut. Let's get you back to the story.
              </p>
              <div className="mt-10 flex flex-wrap items-center gap-6">
                <PrimaryButton to="/" variant="ivory" data-testid="not-found-home-cta">
                  Back to Home
                </PrimaryButton>
                <ArrowLink to="/contact" onDark>
                  Contact LYKIT
                </ArrowLink>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
